import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import RealTimeOccupancySpaceStatusIndicator, {
  RealTimeOccupancySpaceStatus,
} from "../RealTimeOccupancySpaceStatusIndicator";
import Typography from "@mui/material/Typography";

const RealTimeOccupancyMapStatuses: Record<RealTimeOccupancySpaceStatus, string> = {
  available: "Available",
  occupied: "Occupied",
  occluded: "Occluded",
  violation: "Violation",
  doubleparked: "Double Park Violation",
  zoneSelected: "Selected",
  selected: "Selected",
};

export const RealTimeOccupancyMapLegend: React.FC<RealTimeOccupancyMapLegendProps> = ({ loading, filterStatuses }) => {
  return loading ? (
    <Skeleton
      variant="rectangular"
      width={"100%"}
      height={"44px"}
      sx={{
        maxWidth: "750px",
      }}
    >
      <Box width={"100%"} height={"44px"} />
    </Skeleton>
  ) : (
    <Stack
      spacing={2}
      direction="row"
      useFlexGap
      flexWrap="nowrap"
      sx={{
        overflowX: "auto",
        overflowY: "hidden",
        flex: 1,
        minWidth: 0,
        WebkitOverflowScrolling: "touch",
      }}
    >
      {filterStatuses.map((status) => (
        <LegendItem key={status} status={status} />
      ))}
      <LegendItem status="selected" />
    </Stack>
  );
};

interface LegendItemProps {
  status: RealTimeOccupancySpaceStatus;
}

const LegendItem: React.FC<LegendItemProps> = ({ status }) => {
  return (
    <Box display={"flex"} gap={0.5} alignItems={"center"} flexShrink={0}>
      <RealTimeOccupancySpaceStatusIndicator status={status} />
      <Typography variant={"body1"} sx={{ whiteSpace: "nowrap" }}>
        {RealTimeOccupancyMapStatuses[status]}
      </Typography>
    </Box>
  );
};

export interface RealTimeOccupancyMapLegendProps {
  loading: boolean;
  filterStatuses: RealTimeOccupancySpaceStatus[];
}

export default RealTimeOccupancyMapLegend;
